// extracted by mini-css-extract-plugin
module.exports = {"cover":"error_cover__3enCj","logo":"error_logo__195Db","title":"error_title__3QvqC","paragraph":"error_paragraph__2fMT2"};